/**
 * InvoiceIdLink - the invoice identifier on an S3 or S4 row or card, as the link
 * to that invoice's S5 detail (SIH-17 I-8c). It carries the current period into
 * the target URL (Deep-Linked State), so the detail counts the invoice for the
 * same period the list did. A 44px target on a phone (T22).
 */

import { invoicePath, tinOfBranch } from '@domain/tpinPaths'
import { Link } from './Link'
import { useRoute } from './route'

export function InvoiceIdLink({
  dbName,
  rectNo,
  testid,
  children,
}: {
  readonly dbName: string
  readonly rectNo: number
  readonly testid?: string
  readonly children: React.ReactNode
}) {
  const { period } = useRoute()
  return (
    <Link
      to={invoicePath(tinOfBranch(dbName), dbName, rectNo)}
      period={period}
      className="invoice-link"
      testid={testid}
      ariaLabel={`Open invoice ${rectNo}`}
    >
      {children}
    </Link>
  )
}
